import { Component, Inject, OnInit } from '@angular/core';
import { ContactProfile } from 'src/app/api';
import { UiRouterState } from '../../services/ajs-router-state.service';
import { CompletionStatus, TutorialApiService } from '../../services/api/tutorial-api.service';
import { TUTORIAL_PANEL_DATA, TutorialPanelRef } from '../tutorial-panel-ref';
import { MatDialog } from '@angular/material';
import { SelectTourDialogComponent } from 'src/app/tour/select-tour-dialog/select-tour-dialog.component';

@Component({
  selector: 'mandae-tutorial-panel',
  templateUrl: './tutorial-panel.component.html',
  styleUrls: ['./tutorial-panel.component.scss']
})
export class TutorialPanelComponent implements OnInit {

  public missingContacts: ContactProfile[] = [];

  public completeSteps = [
    false,
    false,
    false,
  ];

  public get tutorialComplete(): boolean {
    return this.completeSteps.reduce((a, b) => a && b);
  }

  private stepWeights = [ 0.3, 0.3, 0.4 ];

  public get stepPercent(): string {
    const complete = this.stepWeights
      .map((weight, i) => weight * <any>this.completeSteps[i])
      .reduce((a, b) => a + b);

    return Math.fround(complete * 100) + '%';
  }

  constructor(
    @Inject(TUTORIAL_PANEL_DATA) data: CompletionStatus,
    private panelRef: TutorialPanelRef,
    private tutorialApiService: TutorialApiService,
    private dialog: MatDialog
  ) {
    this.completeSteps[0] = data.contatos;
    this.completeSteps[1] = data.integracoes;
    this.completeSteps[2] = data.coletas;
  }

  ngOnInit() {
  }

  public closePanel() {
    this.panelRef.closePanel();
  }

  public gotoHome() {
    this.tutorialApiService.setTutorialComplete().subscribe(() => {
      this.panelRef.remove();
      this.dialog.open(SelectTourDialogComponent);
    });
  }

  public setMissingContacts(value: ContactProfile[]) {
    setTimeout(() => this.missingContacts = value, 0);
  }

}
